import { toUpper, pipe, toLower, concat } from 'ramda'

export const camelToSnakeCase = (str) =>
  str.replace(/(?!^)[A-Z0-9]/g, pipe(toLower, concat('_')))

export const snakeToCamelCase = (str) =>
  str.replace(/_([a-z0-9])/g, (_, m) => toUpper(m))
